<template>
  <div>
    <div class="breadcrumb-con">
      <div style="display: inline-flex; float: left;">
        <a v-on:click="toRobotList"><i class="el-icon-arrow-left back-icon"></i></a>
        <img v-if="chatbotDetail && chatbotDetail.logo" class="chatbot-logo" :src="chatbotDetail.logo" />
        <img v-else class="chatbot-logo" src="../assets/robot.png" />
        <div class="breadTitle">{{chatbotDetail && chatbotDetail.name || formatMessage({id:'5g.message.h5.components.chat',defaultMessage:'聊天'})}}</div>
      </div>
      <div @click="toLogin" class="returnLogin">{{formatMessage({id:'5g.message.h5.login',defaultMessage:'登录'})}}</div>
    </div>
    <ul class="tutorial-page" ref="historyList" id="historyList" 
      v-bind:style="{height: showActionIcon ? 'calc(100% - 138px)' : 'calc(100% - 108px)'}"
    >
      <li v-for="(item, index) in recordList" tid="createTime" :key="item.createTime" style="list-style: none">
        <div v-if="item.messageSource == 'chatbot'" class="content-item">
          <div class="left" >
            <!-- <img v-if="chatbotDetail && chatbotDetail.logo" class="header-chatbot" :src="chatbotDetail.logo" />
            <img v-else class="header-chatbot" src="../assets/robot.png" /> -->
            <div class="left-line">
              <template-card 
                :data-source="item" 
                @clickLink="rcsHandleClick" 
                :show-btn="index == recordList.length - 1 || (diverLineIndexIsLast && index == recordList.length - 2)"
              ></template-card>
            </div>
          </div>
          <div class="chatTime-left">{{getCreateTime(item.createTime)}}</div>
        </div>
        <div v-else-if="item.messageSource == 'user'" class="content-item">
          <div class="right">
            <img class="header-user" src="../assets/user.png" />
            <div class="right-line">
              <message-type :data-source="item"></message-type>
            </div>
          </div>
          <div class="chatTime-right">
            <span class="time">{{getCreateTime(item.createTime)}}</span>
            <span class="type">{{item.sendType}}</span>
          </div>
        </div>
        <div v-else-if="recordList.length > 1" class="diver-line">
          {{formatMessage({id:'5g.message.h5.chatRoom.hismsg',defaultMessage:'以上为历史消息'})}}
        </div>
      </li>
    </ul>

    <div class="bottom-input" v-bind:style="{height: showActionIcon ? '60px' : '30px' }" >
      <div v-if="showActionIcon" class="bottom-row">
        <el-upload
          class="upload-demo"
          accept="image/*" :show-file-list="false"
          :action="uploadFileUrl"
          :on-success="uploadFileImage"
          :on-error="uploadFileError"
        >
          <img class="left-icon" src="../assets/photo.png" />
        </el-upload>
        <el-upload
          class="upload-demo"
          accept="video/*" :show-file-list="false"
          :action="uploadFileUrl"
          :on-success="uploadFileVideo"
          :on-error="uploadFileError"
        >
        <img class="left-icon" src="../assets/video.png" />
        </el-upload>
        <img @click="toVideoCall" class="left-icon" src="../assets/videoCall.png" />
        <img @click="dialogVisible = true" class="left-icon" src="../assets/location.png" />
      </div>
      <div class="bottom-row">
        <img v-if="showMenu && menuList.length > 0" v-on:click="toggleShowMenu" class="left-icon" src="../assets/keyboard.png" />
        <img v-if="!showMenu && menuList.length > 0" v-on:click="toggleShowMenu" class="left-icon" src="../assets/menu.png" />

        <img v-if="!showMenu || menuList.length == 0" v-on:click="toggleShowIcon" class="left-icon" src="../assets/extraIcon.png"></image>
        <input v-if="!showMenu || menuList.length == 0" :placeholder="formatMessage({id:'5g.message.h5.common.name.plsinput',defaultMessage:'请输入内容'})" v-model="inputValue" 
          v-bind:style="{marginLeft: menuList.length > 0 ? '0px' : '8px' }" class="el-input__inner innerInput ">
        </input>
        <el-button v-if="!showMenu  || menuList.length == 0" class="send-btn" v-on:click="sendTextMessage">{{formatMessage({id:'5g.message.h5.chatRoom.send',defaultMessage:'发送'})}}</el-button>
        

        <div v-if="showMenu && menuList.length > 0"  class="menu-con" >
          <template v-for="menu in menuList">
            <el-dropdown v-if="menu.menu" id="menu.menu.displayText" class="menu-item" @command="handleCommand" trigger="click">
              <span style="display: inline-block; width: 100%">
                {{menu.menu.displayText}}
              </span>
              <el-dropdown-menu slot="dropdown" placement="top-start" class="pop-menu">
                <el-dropdown-item v-for="(subMenu,index) in menu.menu.entries" :key="index" :command="subMenu">
                  <div v-if="subMenu.action" class="pop-menu-item">{{subMenu.action.displayText}}</div>
                  <div v-if="subMenu.reply" class="pop-menu-item">{{subMenu.reply.displayText}}</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <div v-if="menu.action" class="menu-item" v-on:click="handleMenuClick(menu, 'Menu')">{{menu.action.displayText}}</div>
            <div v-if="menu.reply" class="menu-item" v-on:click="handleMenuClick(menu, 'Menu')">{{menu.reply.displayText}}</div>
          </template>
        </div>
      </div>
    </div>

    <div id="currerntMap" ></div>
    <el-dialog custom-class="custom-dialog" :fullscreen="true" v-if="dialogVisible"
      :title="null" :show-close="false" top="0"
      :visible.sync="dialogVisible"
      width="100%"
    >
      <map-location
        @cancle="dialogVisible = false"
        @sendLocation="handleSendLocation"
        @updateCurrentLocation="updateCurrentLocation"
      ></map-location>
    </el-dialog>
    <el-dialog custom-class="custom-dialog" :fullscreen="true" v-if="webFrameVisible"
      :title="null" :show-close="true" top="0"
      :visible.sync="webFrameVisible"
      width="100%"
    >
      <web-container
        @goback="webFrameVisible = false"
        :webUrl="webReallyUrl"
      ></web-container>
    </el-dialog>
  </div>
</template>

<script>
import { queryMenuByServiceNo, queryChatbotByServiceNo, upMessage, uploadFileUrl } from '../services';
import moment from 'moment';
import{ mapState, mapMutations, mapActions }from'vuex';
import qs from 'qs';
import { getParams, postUserDeviceInfo } from '../utils';
import { encode } from 'js-base64';
import { lists, menuList } from './data.js';
import TemplateCard from './templateCard';
import MessageType from './messageType';
import MapLocation from '../components/MapLocation';
import WebContainer from '../components/WebContainer';
let app;
export default {
  name: 'ChatRoom',
  computed: {
    ...mapState({
      mobileNo: state=>state.chatRoom.mobileNo, 
      serviceNo: state=>state.chatRoom.serviceNo,
      channelCode: state=>state.chatRoom.channelCode,
      recordList: state=>state.chatRoom.recordList,
      chatbotList: state=>state.chatbotList.chatbotList,
      apiUrl: state=>state.chatRoom.apiUrl, 
      websocketUrl: state=>state.chatRoom.websocketUrl,
      queryParams: state=>state.chatRoom.queryParams,
    }),
    diverLineIndexIsLast(){
      const recordList = this.recordList || [];
      const lastIndex = this.recordList.length - 1 || -1;
      const diverLineIndex = recordList.findIndex((item, index, arr) => {
        return item.messageSource == 'this';
      }) || -1;
      if(diverLineIndex > 0 && diverLineIndex == lastIndex){
        return true;
      }
      return false;
    }
  },
  data () {
    return {
      canBack: true, // 能否返回服务列表
      inputValue:'',
      extraContent: false,
      selectPhoto: null,
      selectVideo: null,
      selectFile: null,
      selectLocation: null,
      isRecordVoice: false, // 是否正在录音
      selectVoice: null,

      showMenu: true,
      showActionIcon: false, // 显示操作按钮
      menuList: [],

      showLoading: false,
      dialogVisible: false,
      webFrameVisible: false,
      webReallyUrl: '',

      showBreadcrumb: true,
      chatbotDetail: {}, // 服务号详情

      uploadFileUrl: '',

      currentLocation: null, // 当前用户的地址
    }
  },

  components: {
    TemplateCard, MessageType, MapLocation, WebContainer
  },

  methods: {
    ...mapMutations('chatRoom', ['setRecordList','setState']),
    ...mapMutations('chatbotList', ['setChatbotList']),
    // ...mapActions('chatRoom', ['count', 'queryList']),

    toRobotList(){
      this.$router.push('/')
    },

    showMap(){
      this.$router.push('/map')
    },

    toLogin(){
      this.$router.push('/login')
    },
    uploadFileVideo(response, file, fileList){
      this.uploadFile(response, file, fileList,'video');
    },
    uploadFileImage(response, file, fileList){
      this.uploadFile(response, file, fileList,'image');
    },
    uploadFile(response, file, fileList,fileType){
      const { name, raw: { type } } = file;
      if(response&& response.data){
        const [url] = response.data;
        const file_message = { 
          createTime: new Date().getTime(),
          messageSource: 'user',
          sendType: 'FILE',
          file: {
            fileContentType: type,
            fileUrl: url,
            fileName: name
          },
        };
        const params = {
          serviceNo: this.serviceNo,
          mobileNo: this.mobileNo,
          channelCode: this.channelCode,
          contentType: fileType,
          reply: url
        };
        this.setNewMessage(file_message);
        this.handleUpMessage(params, file_message.createTime);
      }
    },

    uploadFileError(){
      this.$message({
        message: this.formatMessage({id:'5g.message.h5.tipmsg.msg2',defaultMessage:'文件上传失败！发送失败！'}),
        type: 'error'
      })
    },

    updateCurrentLocation(location){
      console.log('获取当前地址', location)
      this.currentLocation = location;
    },

    handleSendLocation(location){
      console.log('地址上报', location)
      if(location){
        this.showLoading = true;
        const geo_message = { 
          createTime: new Date().getTime(),
          messageSource: 'user',
          sendType: 'LOCATION',
          location
        };
        const reply = `geo:${location.latitude},${location.longitude};u=40.0;crs=gcj02;rcs-l=${location.address}`
        const params = {
          serviceNo: this.serviceNo,
          mobileNo: this.mobileNo,
          channelCode: this.channelCode,
          contentType: 'text',
          reply
        };
        this.setNewMessage(geo_message);
        this.handleUpMessage(params, geo_message.createTime);
        this.dialogVisible = false;
        this.showLoading = false;
      }
    },

    async getMenu(){
      const params = {
        serviceNo: this.serviceNo,
        mobileNo: this.mobileNo
      };
      const response = await queryMenuByServiceNo(params, this.apiUrl);
      if(response && response.data){
        if(response.data instanceof Array){
          this.menuList = response.data;
        } else {
          this.menuList = []
        }
      }
    },

    async getChatbotDetail(){
      const params = {
        serviceNo: this.serviceNo,
        phone: this.mobileNo
      };
      const response = await queryChatbotByServiceNo(params, this.apiUrl);
      if(response && response.data){
        const { maapServiceNo, logo, name } = response.data;
        this.chatbotDetail = {maapServiceNo, logo, name}
      } else {
        this.$message({
          message: this.formatMessage({id:'5g.message.h5.tipmsg.msg3',defaultMessage:'查询服务号详情失败'}),
          type: 'error'
        })
      }
    },

    getRecordList(){
      const { mobileNo, serviceNo, channelCode } = this;
      
      const recordList = localStorage.getItem(`${serviceNo}+${mobileNo}+recordList`)
      if (recordList) {
        try {
          const dataList = JSON.parse(recordList)
          console.log('localStorage.get聊天记录', dataList)
          if (dataList.length > 0) {
            this.setRecordList(dataList)
          } else {
            this.setRecordList([])
          }
        } catch (err) {
          this.setRecordList([])
        }
      } else {
        this.setRecordList([])
      }
      setTimeout(()=>{
        this.scrollToBottom()
      }, 500)
    },

    updateChatbotList(latestMsg){
      const newList = [...this.chatbotList];
      const { mobileNos, serviceNo, createTime, latestMessage, apiUrl, websocketUrl } = latestMsg;
      const thisChatbotIndex = newList.findIndex(item=> item.maapServiceNo == serviceNo);
      console.log('setNewMessage', thisChatbotIndex, newList[thisChatbotIndex]);
      if(thisChatbotIndex > -1){
        newList[thisChatbotIndex].apiUrl = apiUrl;
        newList[thisChatbotIndex].websocketUrl = websocketUrl;
        newList[thisChatbotIndex].hasUnReadMessage = false;
        newList[thisChatbotIndex].latestMessage = latestMessage;
        newList[thisChatbotIndex].latestTime = createTime;
        const thisService = newList.splice(thisChatbotIndex, 1)
        newList.splice(0, 0, ...thisService)
      } else {
        const thisService = this.chatbotDetail;
        if(thisService){
          newList.unshift({
            ...thisService,
            apiUrl: this.apiUrl, websocketUrl: this.websocketUrl,
            hasUnReadMessage: false,
            latestMessage: latestMessage,
            latestTime: createTime
          })
        }
      }
      this.setChatbotList(newList);
      localStorage.setItem(`chatbotList+${this.mobileNo}`, JSON.stringify(newList));
    },

    getLatestMessage(){
      const recordList = this.recordList.filter(item => item.messageSource !== 'this');
      console.log('111111 recordList', recordList)
      if(recordList && recordList.length > 0){
        const latestMsg = recordList[ recordList.length - 1];
        console.log('111111 latestMsg', latestMsg)
        if(latestMsg){
          const { sendType, bodyText, file, location, reply, sceneTemplateName, createTime } = latestMsg;
          let messageString;
          if(sendType == 'TEMPLATE' || sceneTemplateName){
            messageString = '【'+this.formatMessage({id:'5g.message.h5.common.name.tem',defaultMessage:'模板'})+'】' + sceneTemplateName
          }
          if(sendType == 'TEXT' || bodyText){
            messageString = bodyText || '【'+this.formatMessage({id:'5g.message.h5.common.name.text',defaultMessage:'文本'})+'】'
          }
          if(sendType == 'REPLY' && reply){
            messageString = reply.replyName
          }
          if(sendType == 'LOCATION' && location){
            messageString = '【'+this.formatMessage({id:'5g.message.h5.common.name.addressSb',defaultMessage:'地址上报'})+'】'
          }
          if(sendType == 'FILE'){
            if(file && RegExp(/image\/*/).test(file.fileContentType)){
              messageString = '【'+this.formatMessage({id:'5g.message.h5.common.name.img',defaultMessage:'图片'})+'】'
            } else if (file && RegExp(/video\/*/).test(file.fileContentType)){
              messageString = '【'+this.formatMessage({id:'5g.message.h5.common.name.video',defaultMessage:'视频'})+'】'
            } else if(file && RegExp(/audio\/*/).test(file.fileContentType)){
              messageString = '【'+this.formatMessage({id:'5g.message.h5.common.name.audio',defaultMessage:'音频'})+'】'
            } else {
              messageString = '【'+this.formatMessage({id:'5g.message.h5.common.name.file',defaultMessage:'文件'})+'】'
            }
          }
          return { messageString, createTime }
        }
      }
    },

    async sendTextMessage() {
      if (this.inputValue) {
        this.showLoading = true;
        const text_message = { 
          createTime: new Date().getTime(),
          messageSource: 'user',
          sendType: 'TEXT',
          bodyText: this.inputValue
        };
        const params = {
          serviceNo: this.serviceNo,
          mobileNo: this.mobileNo,
          channelCode: this.channelCode,
          contentType: 'text',
          reply: this.inputValue
        }
        this.setNewMessage(text_message);
        this.handleUpMessage(params, text_message.createTime);
        this.inputValue = '';
        this.showLoading = false;
      } else {
        this.$message({
          message: this.formatMessage({id:'5g.message.h5.common.name.plsinput',defaultMessage:'请输入内容！'}),
          type: 'warning'
        });
      }
    },

    setNewMessage(message){
      this.setRecordList([...this.recordList, message])
      setTimeout(()=>{
        this.scrollToBottom()
      },500)
    },

    scrollToBottom(){
      console.log('historyList scrollHeight',this.$refs.historyList.scrollHeight)
      const historyList = this.$refs.historyList;
      historyList.scrollTo(1000, historyList.scrollHeight)
      // window.scrollTo(1000,historyList.scrollHeight)
    },

    toggleShowIcon(){
      this.showActionIcon = !this.showActionIcon;
    },

    toVideoCall(){
      location.href = `https://bizapp.5gomsg.com/5gmsg-ui/#/agent/call?mobileNo=${this.mobileNo}&serviceNo=${this.serviceNo}`
    },

    toggleShowMenu(){
      this.showMenu = !this.showMenu
    },
    getCreateTime(data){
      return moment(data).format('YYYY-MM-DD HH:mm:ss')
    },

    handleUpMessage(params, createTime){
      const _this = this;

      const doUpMessage = async () => {
        const response = await upMessage({...params, ..._this.queryParams}, _this.apiUrl);
          if(response && (response.status == 200||response.success)){
            console.log('上行成功')
          } else {
            console.log('上行失败',response)
            const messageIndex = _this.recordList && _this.recordList.findIndex(item=>item.createTime == createTime);
            if(messageIndex > -1){
              _this.recordList[messageIndex].error = true;
            }
          }
      };
      doUpMessage();
    },

    upAction(replyAction, replySource){
      if(replyAction){
        this.showLoading = true;
        const { displayText, postback } = replyAction;
        const params = {
          serviceNo: this.serviceNo,
          mobileNo: this.mobileNo,
          channelCode: this.channelCode,
          contentType: 'reply',
          reply: replyAction
        }
        const _this = this;
        const action_message = { 
          createTime: new Date().getTime(),
          messageSource: 'user',
          sendType: 'REPLY',
          reply: {
            replyName: displayText,
            replySource: replySource || 'Menu', // MENU 
          }
        };
        _this.setNewMessage(action_message);
        _this.handleUpMessage(params, action_message.createTime);
        // this.closeExtra();
        this.showLoading = false;
      }
    },

    handleCommand(command) {
      console.log('command', command);
      if(command){
        this.handleMenuClick(command, 'Menu');
      }
    },

    getLocation(){
      const _this = this;
      const map = new AMap.Map('currerntMap');
      map.plugin(['AMap.Geolocation'], function () {
        const geolocation = new AMap.Geolocation({
            enableHighAccuracy: true,//是否使用高精度定位，默认:true
            timeout: 1000,          //超过10秒后停止定位，默认：无穷大
            maximumAge: 0,           //定位结果缓存0毫秒，默认：0
            convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: true,        //显示定位按钮，默认：true
            showMarker: false,        //定位成功后在定位到的位置显示点标记，默认：true
            showCircle: false,        //定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
            // noIpLocate: 3, // 所有终端禁止使用IP定位
        });
        map.addControl(geolocation);
        
        const onComplete = (status,result) => {
          console.log('自动定位', status,result)
          if(status == 'complete'){
            const { position, formattedAddress } = result;
            _this.currentLocation = { ...position, formattedAddress };
          }
        }
        geolocation.getCurrentPosition(onComplete);
      });
    },

    async handleMenuClick(link, replySource = 'Menu'){
      console.log('link click', link);
      const _this = this;
      const { action, reply } = link;
      const doUpMessage = async (params) => {
        const response = await upMessage({...params, ..._this.queryParams,hideErrorTip:true}, _this.apiUrl);
        if(response && (response.status == 200||response.success)){
          console.log('action 点击上行成功！');
        } else {
          console.log('action 点击上行失败')
        }
      };

      if(action){
        const { postback, urlAction, dialerAction, composeAction, calendarAction,
          mapAction, deviceAction } = action;

        const upParams = {
          contentType: "reply",
          mobileNo: this.mobileNo,
          serviceNo: this.serviceNo,
          reply: {...action},
        };
        doUpMessage(upParams);
        
        if(urlAction && urlAction.openUrl){ // 跳转网页
          const { url } = urlAction.openUrl;
          console.log('urlAction url', url);
          window.open(url, "_blank",  "scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes")
          // this.webFrameVisible = true;
          // this.webReallyUrl = url;
          // debugger;
          // localStorage.setItem('urlActionNeedReply', false);
          // // location.href = url;
          // const encodeUrl = encodeURIComponent(url)
          // // this.$router.push({ 
          // //   name: 'webContainer', 
          // //   params: { 
          // //     webUrl: encodeUrl
          // //   }
          // // })
          // // console.log('encodeUrl', encodeUrl)
          // this.$router.push(`/web/${encodeUrl}`)
        } else if(dialerAction && dialerAction.dialPhoneNumber){ // 打电话
          const { phoneNumber } = dialerAction.dialPhoneNumber;
          location.href = `tel:${phoneNumber}`;
        } else if(composeAction && composeAction.composeTextMessage){ // 定向发送短信
          const { phoneNumber, text } = composeAction.composeTextMessage;
          var u = navigator.userAgent;
          var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
          var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          if(isiOS){
            location.href = `sms:${phoneNumber}&body=${text}`;
          } else {
            location.href = `sms:${phoneNumber}?body=${text}`;
          }
        } else if(deviceAction){
          postUserDeviceInfo(this.mobileNo);
          this.$message({
            message: this.formatMessage({id:'5g.message.h5.tipmsg.msg4',defaultMessage:'设备信息上报成功！'}),
            type: 'success'
          })
        } else if(mapAction){// 打开地图，地址上报
          const { requestLocationPush, showLocation } = mapAction;
          if(requestLocationPush){ // 地址上报
            this.dialogVisible = true;
          }
          if(showLocation){ // 打开地图
            const { location: { latitude, longitude, label, query } } = showLocation;
            if(!latitude && !_this.currentLocation){
              _this.getLocation();
            }
            this.$confirm(this.formatMessage({id:'5g.message.h5.tipmsg.msg5',defaultMessage:'请选择打开地图'}), this.formatMessage({id:'5g.message.h5.common.name.tip',defaultMessage:'提示'}), {
              distinguishCancelAndClose: true,
              confirmButtonText: '高德地图',
              cancelButtonText: '百度地图',
              type: 'info',
              center: true,
              customClass: 'alertCon',
              
            }).then((action) => { // 高德地图
              console.log('高德地图')
              if(action == 'confirm'){
                if(latitude && longitude){ // 打开地图
                  location.href = `https://uri.amap.com/marker?position=${longitude},${latitude}&name=${label}`;
                } else if(query) { // 位置推送
                  const { lng, lat } = _this.currentLocation || {};
                  location.href = `https://uri.amap.com/search?keyword=${query}&center=${lng},${lat}&view=map&src=mypage&callnative=0&innersrc=uriapi`;
                }
              }
            }).catch((action) => { // 百度地图
              if(action == 'cancel') {
                console.log('百度地图')
                if(latitude && longitude){
                  location.href = `http://api.map.baidu.com/marker?location=${latitude},${longitude}&title=${label || '位置'}&content=${label || '位置'}&output=html&src=webapp.baidu.openAPIdemo`;
                } else if(query) {
                  const { lng, lat } = _this.currentLocation || {};
                  location.href = `http://api.map.baidu.com/place/search?query=${query}&location=${lat},${lng}&output=html&src=webapp.baidu.openAPIdemo`;
                }
              }
            });
          }
          // this.$message({
          //   message: '暂不支持该地址上报',
          //   type: 'warning'
          // })
        } else {// 其他功能不支持
          this.$message({
            message: this.formatMessage({id:'5g.message.h5.tipmsg.msg6',defaultMessage:'暂不支持该功能！'}),
            type: 'warning'
          })
        }
      }
      if(reply){
        this.upAction(reply, replySource);
      }
    },

    rcsHandleClick(link) {
      console.log('rcsHandleClick', link);
      if(link){
        this.handleMenuClick(link, 'RCS');
      }
    }

  },

  async created(){
    app = this.$parent;
    this.uploadFileUrl = this.apiUrl + uploadFileUrl;
    console.log('聊天页面  created====')
    const urlParams = await getParams();
    const urlActionNeedReply = localStorage.getItem('urlActionNeedReply') || 'false';
    if(urlParams){
      const { mobileNo, serviceNo, channelCode, reply } = urlParams || {};
      if(RegExp(/^100+/).test(mobileNo)){
        this.canBack = false;
      }
      this.setState({ mobileNo, serviceNo, channelCode })
      localStorage.setItem('mobileNo', mobileNo);
      localStorage.setItem('mobileNoLoginStatus', true);
      // 无需判断，每次进入聊天室建立连接
      console.log('room createWebSocket')
      app.createWebSocket(this.websocketUrl);
      this.getMenu()
      this.getChatbotDetail()
      this.getRecordList()
      
      if(reply && serviceNo && urlActionNeedReply == 'true'){
        postUserDeviceInfo(mobileNo);
        setTimeout(()=>{
          const text_message = { 
            createTime: new Date().getTime(),
            messageSource: 'user',
            sendType: 'TEXT',
            bodyText: reply && reply.displayText || '你好'
          };
          // this.setNewMessage(text_message);
          this.handleUpMessage({...urlParams, contentType: "reply"}, text_message.createTime);
        }, 500)
      }

    }
    
    console.log('this app', this.$parent)
  },

  beforeDestroy(){
    const { mobileNo, serviceNo, channelCode, apiUrl, websocketUrl } = this;
    console.log('beforeDestroy mobile, serviceNo', mobileNo, serviceNo)
    // 更新机器人列表中最新的消息
    const latestMsg = this.getLatestMessage();
    console.log('latestMsg', latestMsg);
    if(latestMsg){
      this.updateChatbotList({
        serviceNo, mobileNos: mobileNo, apiUrl, websocketUrl,
        latestMessage: latestMsg.messageString,
        createTime: latestMsg.createTime,
        operationType: 'update'
      });
    }

    const newlist = this.recordList.filter(item => item.messageSource !== 'this') || [];
    if(newlist.length > 0){
      newlist.push({
        createTime: new Date().getTime(),
        messageSource: 'this',
      })
    }
    const recordListString = JSON.stringify(newlist)
    localStorage.setItem(`${serviceNo}+${mobileNo}+recordList`, recordListString);
    
  }
}
</script>

<style lang="less" scoped>
  @import './styles.less';
  .header-chatbot{
    object-fit: contain;
    width: 40px;
    height: 40px;
    /* background-color: #e1f0fd; */
    background-color: #fff;
    border-radius: 20px;
  }
  .header-user{
    width: 30px;
    height: 30px;
    padding: 5px;
    background-color: #eaefeb;
    border-radius: 20px;
  }
  .innerInput{
    width: 100%;
    margin-left: 0px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border: 1px solid #DCDFE6;
    border-right: none;
    border-radius: 4px 0 0 4px;
    padding: 0 15px;
    background-color: #FFF;
    color: #606266;
  }
</style>


// WEBPACK FOOTER //
// src/chatRoom/index.vue